import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { post } from 'src/services/httpClient.service';

const ScreenTracker = () => {

  const location = useLocation();
  const previousPath = useRef(null);

  const getBrowserName = () => {
    const ua = navigator.userAgent;

    if (ua.includes("Edg")) return "Microsoft Edge";
    if (ua.includes("Chrome")) return "Google Chrome";
    if (ua.includes("Firefox")) return "Mozilla Firefox";
    if (ua.includes("Safari")) return "Safari";
    if (ua.includes("Opera") || ua.includes("OPR")) return "Opera";

    return "Unknown";
  };

  const browserInfo = {
    userAgent: navigator.userAgent,
    platform: navigator.platform,
    language: navigator.language,
    cookieEnabled: navigator.cookieEnabled,
    online: navigator.onLine,
  };

  useEffect(() => {
    console.log('Current:', location.pathname);
    console.log('Previous:', previousPath.current);

    // Skip API call for logout/root page
  if (location.pathname === '/' || location.pathname === '/login') {
    previousPath.current = location.pathname;
    return;
  }

    const payload = {
      screenPath: location.pathname,
      previousScreen: previousPath.current,
      browserInfo: browserInfo
    };

    previousPath.current = location.pathname;

    post(`${process.env.REACT_APP_BASE_API_URL}/api/audit-logs/redirection_log/save`, payload);

    console.log("payload:::", payload)

  }, [location]);

  return null;
  // const location = useLocation();
  // const previousPath = useRef(null);

  // useEffect(() => {
  //   console.log('Current:', location.pathname);
  //   console.log('Previous:', previousPath.current);
  //   const trackScreen = async () => {
  //     try {
  //       const operatorData = JSON.parse(
  //         localStorage.getItem('operatorData') || '{}'
  //       );

  //       const payload = {
  //         screenPath: location.pathname,
  //         name: operatorData?.operatorName,
  //         userId: operatorData?.id,
  //         action: 'REDIRECT'
  //       };
  //       console.log("location:::", location)
  //       return;
  //       console.log('payload2',payload)

  //       await post(
  //         `${process.env.REACT_APP_BASE_API_URL}/api/audit-logs/redirection_log/save`,
  //         payload
  //       );

  //       console.log('Tracked:', location.pathname);
  //     } catch (error) {
  //       console.error('Tracking failed', error);
  //     }
  //   };

  //   trackScreen();
  // }, [location.pathname]);

  // return null;
};

export default ScreenTracker;